export default __webpack_public_path__ + "static/media/IPS.33ca9a55.png";